import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=2355e582&scoped=true&"
import script from "./CBadge.vue?vue&type=script&lang=js&"
export * from "./CBadge.vue?vue&type=script&lang=js&"
import style0 from "./CBadge.vue?vue&type=style&index=0&id=2355e582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355e582",
  null
  
)

export default component.exports